import { useQuery } from '@tanstack/react-query';

import { clientAxios } from '@/shared/api';
import { AuthorListQueryParams } from '@/shared/types';
import { convertAuthorItem } from '@/shared/utils';

const useAuthorListQuery = ({
  isSubscribed,
  page,
}: Omit<AuthorListQueryParams, 'query'>) => {
  return useQuery({
    queryKey: ['authorList', page, isSubscribed],
    queryFn: async () => {
      const { data } = await clientAxios.get('/authorListApi/', {
        params: { isSubscribed, page },
      });

      return {
        count: data.data.count,
        maxPage: Math.ceil(data.data.count / 10),
        authors: convertAuthorItem(data.data.results),
      };
    },
  });
};

export default useAuthorListQuery;
